import { render, staticRenderFns } from "./SelectActivo.vue?vue&type=template&id=946c77d6&"
import script from "./SelectActivo.vue?vue&type=script&lang=js&"
export * from "./SelectActivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports